module.exports = __webpack_public_path__ + "assets/img/recharge.0a17b99c.png";